import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from "react-redux";
import "../../../assets/css/common/breadcrumb.css";
import { FiChevronRight } from "react-icons/fi";
import { Link, useParams, useNavigate } from "react-router-dom";
import {
    getStaffRegister, postStaffRegister, postStaffRegisterClear
} from "../../../../store/slices/staffRegister";
import ManageStaffRegisterForm from './manageStaffRegisterForm';
import { Alert } from "@mui/material";

const ManageStaffRegister = (props) => {
    const { id } = useParams();
    let navigate = useNavigate();
    const dispatch = useDispatch();
    const [data, setData] = useState(null);
    const [preFilledData, setPreFilledData] = useState("");
    const { staffRegister, postStaffRegisterData, message, postStaffRegisterError } = useSelector((state) => state.staffRegisterReducer);

    useEffect(() => {
        if (id) {
            dispatch(getStaffRegister({ uid: id }))
        }
        else {
            dispatch(getStaffRegister())
        }
    }, [])

    useEffect(() => {
        if (staffRegister) {
            setData(staffRegister);
        }
    }, [staffRegister]);

    useEffect(() => {
        if (message) {
            setTimeout(() => {
                if ((postStaffRegisterData) && message) {
                    dispatch(postStaffRegisterClear());
                    navigate("/cms/permission/staff-register")
                } else {
                    dispatch(postStaffRegisterClear());
                }
            }, 5000);
        }
    }, [message]);

    const newValues = {
        email: null,
        password: null,
        confirmPassword: null,
        group: null,
        is_active: null,
    };

    useEffect(() => {
        if (id) {
            const selectedItems = data?.groups?.filter(item => item.is_selected == true);
            let activeData = data?.active;
            const preFilledValue = {
                email: data?.users[0],
                is_active: activeData,
                group: selectedItems
            };
            setPreFilledData(preFilledValue);
        }
    }, [id, data]);

    const searchUser = (value) => {
        dispatch(getStaffRegister({ search_user: value }))
    }

    const submit = (values) => {
        const params = {};
        if (values?.email?.email)
            params.email = values?.email?.email
        if (values?.password)
            params.password = values?.password;
        if (values?.confirmPassword)
            params.confirm_password = values?.confirmPassword;
        if (values?.group)
            params.group = values?.group?.map(obj => obj.id);
        if (values?.is_active)
            params.is_active = values?.is_active == true ? 1 : 0;
        dispatch(postStaffRegister(params));
    };
    const onCancel = () => {
        navigate(`/cms/permission/staff-register`);
    };
    return (
        <>
            <div className='block_user'>
                <h4>Manage Staff Register</h4>
                <div className={"custom_breadcrumb"}>
                    <ul className={"custom_breadcrumb_ul"}>
                        <li className={"custom_breadcrumb_list"}>
                            <Link to="/cms/">
                                <a className={"sub_nan_anchor"}>Home</a>
                            </Link>
                        </li>
                        <li className={"custom_breadcrumb_list"}>
                            <span>
                                <FiChevronRight />
                            </span>
                        </li>
                        <li className={"custom_breadcrumb_list"}>
                            <Link to="/cms/permission/staff-register">
                                <a className={"sub_nan_anchor"}>Staff Register</a>
                            </Link>
                        </li>
                        <li className={"custom_breadcrumb_list"}>
                            <span>
                                <FiChevronRight />
                            </span>
                        </li>
                        <li className={`${"custom_breadcrumb_list"} ${"custom_breadcrumb_list_active"}`}>
                            {id ? "Edit Registered Staff" : "Add Staff"}
                        </li>
                    </ul>
                </div>
                <div className={"notification_popup"}>
                    {(message &&
                        <Alert
                            severity={
                                postStaffRegisterError
                                    ? `error`
                                    : `success`
                            }
                        >
                            {" "}
                            {message}{" "}
                        </Alert>
                    )}
                </div>
                {/* Add staff */}
                {!id && (<ManageStaffRegisterForm
                    listData={data?.users}
                    groupData={data?.groups}
                    fieldData={data}
                    submit={(e) => submit(e)}
                    initialValues={newValues}
                    onCancel={onCancel}
                    searchUser={(e) => searchUser(e)}
                />
                )}
                {/* Edit Staff */}
                {id && (
                    <ManageStaffRegisterForm
                        listData={data?.users}
                        groupData={data?.groups}
                        fieldData={data}
                        submit={(e) => submit(e)}
                        initialValues={preFilledData}
                        onCancel={onCancel}
                    />
                )}
            </div>
        </>
    );
};

export default ManageStaffRegister;